module.exports = __webpack_public_path__ + "media/images/gift/steps/gift_box-cd11857b422f5c5cb7a37e99bd9e544e.png";